/* stylelint-disable no-descending-specificity */
import styled from 'styled-components';
import theme from 'styled-theming';
import { Modal } from '../../../UI/Modal';

const headerBackground = theme('name', {
  light: 'rgb(255, 255, 255)',
  dark: 'rgb(41, 41, 41)',
});

const backgroundColorThead = theme('name', {
  light: '#fff',
  dark: 'rgb(52, 52, 52)',
});

export const BeachSwapWrapper = styled.div`
  min-height: calc(100vh - 100px);
  display: flex;
  flex-direction: column;

  .card {
    padding-bottom: unset;
  }

  .header-with-close {
    display: flex;
    gap: 12px;
    align-items: center;
  }

  .filter-card {
    padding: 15px 20px;
    margin-bottom: 0;
    position: relative;
    z-index: 2;
  }

  .table-card {
    padding-bottom: unset;
    position: relative;
    z-index: 1;
    flex: 1;
  }

  .mt-3 {
    margin-top: 15px;
  }

  .heading {
    display: flex;
    .shell-text-heading {
      margin-right: 5px;
    }
  }
  .last-refreshed {
    color: rgb(0, 133, 87);
    font-size: 15px;
    align-self: center;
    font-weight: 500;
  }

  .filter-container {
    margin-left: 4px;
    margin-bottom: 12px;
    justify-content: space-between;
    width: 100%;
    position: relative;
    z-index: 2;

    .button-wrapper {
      padding-right: 0;
    }

    .filters {
      display: flex;
      gap: 20px;
    }

    .select-filter {
      width: 135px;
      .shell-select-container-selection-item {
        font-weight: 600;
      }
    }

    .date-range {
      width: 270px;
      position: relative;
      .shell-date-picker-dropdown-root {
        position: absolute;
        z-index: 20;
      }

      .shell-range-calendar-panel {
        position: absolute;
        z-index: 20;
      }

      .shell-picker {
        width: 100% !important;
      }
    }

    span {
      font-weight: 500;
      min-width: fit-content;
      font-size: 14px;
    }

    .energy {
      display: flex;
      span {
        align-self: center;
        margin-right: 10px;
      }
    }
  }
  .button-wrapper {
    display: flex;
    justify-content: flex-end;
    padding-right: 12px;
    gap: 5px;
    .shell-toggle span {
      margin: 0 10px 0 5px;
    }
  }
  .show-success-status {
    display: flex;
  }
  .grid-actions {
    display: flex;
    button:last-child {
      margin-left: 5px;
    }
  }
  .aligne-status {
    width: fit-content;
    min-width: 80px;
    min-height: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 8px;
    border-radius: 16px;
    color: rgba(255, 255, 255, 1);
    font-weight: 500;
    font-size: 13px;
    &.not_requested {
      background-color: white;
      border: 1px solid rgba(0, 0, 0, 0.15);
      color: rgba(64, 64, 64, 1);
    }
    &.submitted {
      background-color: rgba(251, 207, 9, 1);
      color: rgba(64, 64, 64, 1);
    }
    &.success {
      background-color: rgba(28, 132, 80, 1);
    }
    &.failure {
      background-color: rgba(217, 54, 56, 1);
    }
  }

  .status-pending,
  .status-sent,
  .status-success,
  .status-failure {
    width: fit-content;
    min-width: 80px;
    min-height: 24px;
    display: flex;
    -webkit-box-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    align-items: center;
    padding: 0 8px;
    border-radius: 16px;
    color: white;
    font-weight: 500;
    font-size: 13px;
  }

  .status-pending {
    background-color: white;
    border: 1px solid rgba(0, 0, 0, 0.15);
    color: rgba(64, 64, 64, 1);
  }

  .status-sent {
    background-color: rgb(0, 133, 87);
  }

  .status-success {
    background-color: rgb(0, 133, 87);
  }

  .status-failure {
    background-color: rgb(220, 20, 60);
  }

  .match-energy {
    color: rgb(0, 133, 87) !important;
    font-weight: 600;
  }

  .unmatch-energy {
    color: rgb(220, 20, 60) !important;
    font-weight: 600;
  }

  .upload-progress {
    display: flex;
    justify-content: center;
    .shell-alert {
      width: fit-content;
      div:has(.refresh-beachSwap_noms) {
        display: flex;
        flex-direction: row;
        align-items: center;
      }
      .refresh-beachSwap_noms {
        text-decoration: underline;
      }
    }
  }
  .table-container {
    max-height: calc(100vh - 460px);
  }
  .mapping-table {
    max-height: calc(100vh - 200px);
    .table-container {
      max-height: calc(100vh - 290px);
    }
  }
`;

export const BeachSwapModalWrapper = styled.div`
  .addedit-beach-swap-form {
    .shell-date-picker-dropdown {
      position: fixed;
    }
  }
`;

export const ColumnTitleContainer = styled.div`
  display: flex;
  .sorting-wrapper {
    display: flex;
    .shell-table-column-sorter {
      margin: unset;
      svg:first-child path {
        fill: ${(prop) => prop.color};
      }
    }
    .shell-table-column-title {
      display: flex;
      align-items: center;
    }
  }
  .pointer {
    cursor: pointer;
  }
`;

export const TableLoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgb(0, 0, 0, 0.05);
  z-index: 1000;

  .loader-wrapper {
    background-color: #fff;
    padding: 15px;
    border-radius: 4px;
  }
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 10px 15px;
  button:last-child {
    margin-left: 10px;
  }
  &.upload-aligne {
    .button-wrapper {
      display: flex;
    }
  }
  &.upload-aligne__confirm {
    justify-content: space-between;
    .message {
      display: flex;
      align-items: center;
      margin-right: 10px;
      font-weight: 500;
      color: rgba(217, 54, 56, 1);
    }
  }
`;

export const AuditDetailWrapper = styled.div`
  min-height: 250px;
  max-height: 60vh;
  overflow-y: auto;
  .title {
    font-weight: 600;
    font-size: 14px;
  }
  .logs-info {
    width: 25px;
    height: 25px;
    min-height: 25px;
    margin-left: 5px;
  }
  th,
  td {
    background-color: unset !important;
  }
  tr td:first-child {
    width: 70%;
    text-align: left;
    padding-left: 12px;
  }
  .shell-table tr:hover td {
    background-color: unset !important;
  }

  pre {
    background: rgba(0, 0, 0, 0.1);
    color: unset;
    padding: 5px;
    border-radius: 3px;
  }
  .__json-pretty__ .__json-value__ {
    color: rgb(51, 204, 51);
  }
  .__json-pretty__ .__json-key__ {
    color: #eb0f5f;
  }
`;

export const BeachSwapConsentTitle = styled.h4`
  color: rgb(103 106 108 / 85%);
  font-weight: 400;
  font-size: 18px;
`;

export const BeachSwapBoodyContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
`;

export const BeachSwapModalInfo = styled.div`
  margin-top: 15px;
  p {
    margin: 0 0 10px;

    &:last-child {
      margin-bottom: 0;
    }

    &.note-error-color {
      color: #f00;

      strong {
        &:first-child {
          color: #262626;
        }
      }
    }
  }
`;

export const TableWrapper = styled.div`
  max-height: 500px;
  overflow-y: auto;
  padding: 0 10px;

  thead {
    position: sticky;
    top: 0;
    background-color: ${headerBackground};
  }
`;

export const ConfirmModal = styled(Modal)`
  .shell-modal-container-mask {
    z-index: 4;
  }
  .shell-modal-container {
    width: 85% !important;
  }
  .shell-table-container {
    max-height: 50vh;
    position: relative;
    overflow-y: auto;
  }
  .shell-table-thead {
    position: sticky;
    top: 0;
    z-index: 10;
  }

  .zKey_wrapper {
    display: flex;
    align-items: center;
    button {
      margin-left: 3px;
    }
  }
  .shell-text-input {
    width: 180px;
  }
  .shell-select-container {
    width: 150px;
  }
  .table-container {
    max-height: 600px;
    overflow: auto;

    thead {
      position: sticky;
      top: 0;
      z-index: 1;
      background-color: ${backgroundColorThead};
    }
  }
  .status-checkbox {
    margin-top: 8px;
  }
  .confirm-dropdown {
    width: 180px;
    .shell-select-dropdown {
      position: fixed;
    }
  }
`;

export const InformationModal = styled(Modal)`
  .button-style {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    padding: 10px;
  }
  .shell-modal-container-content {
    min-height: 120px;
  }
  .add-trade-date-picker {
    .shell-date-picker-dropdown {
      position: fixed;
    }
  }
`;
